<template>
  <v-container class="pa-0 ma-0">
    <v-card outlined class="pa-4 ma-0" style="height: 413px">
      <!-- header-->
      <v-container class="chart-header d-flex flex-column pa-0 ma-0">
        <v-card-text class="pa-0 ma-0 text-body-1"> {{ $t("cashFlow") }} </v-card-text>
        <v-card-text class="pa-0 ma-0 text-body-2 gray--text">
          {{ $t("cashInflowOutflowTrendLastSixMonths") }}
        </v-card-text>
      </v-container>

      <!-- line chart-->
      <apexchart
        v-if="hasData"
        type="area"
        height="337"
        width="100%"
        :options="chartOptions"
        :series="chartSeries"
      />
      <v-container
        v-else
        class="pa-0 ma-0 d-flex flex-column align-center justify-center"
        style="height: 337px"
      >
        <img
          :src="require('@/assets/dashboard/no-data(3).png')"
          max-width="100"
          height="100"
          contain
          class="mb-3"
        />
        <v-card-text class="text-body-2 grey--text text-center">
          {{ $t("nothing-for-render") }}
        </v-card-text>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    filterChart: {
      type: Object,
      default: null,
    },
    advanceFilter: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      chartApiResponse: {},
      loading: false,
    };
  },
  computed: {
    hasData() {
      return this.chartSeries.some((series) => series.data.some((val) => val > 0));
    },
    chartCategories() {
      const values = Object.values(this.chartApiResponse || {});
      let lastSixMonths = values.slice(-6);
      return lastSixMonths.map((item) => item.label);
    },
    chartSeries() {
      const values = Object.values(this.chartApiResponse || {});
      let lastSixMonths = values.slice(-6);
      const payments = lastSixMonths.map(
        (item) => item.monthlyInvoices?.profit?.cost ?? 0
      );

      const incomings = lastSixMonths.map(
        (item) => item.monthlyInvoices?.profit?.income ?? 0
      );
      return [
        {
          name: this.$t("payment"),
          data: payments,
        },
        {
          name: this.$t("incoming"),
          data: incomings,
        },
      ];
    },
    chartOptions() {
      return {
        chart: {
          type: "area",
          toolbar: { show: false },
          fontFamily: "IRANSans",
        },

        stroke: {
          curve: "smooth",
          width: 2,
        },

        colors: ["#10b981e2", "#EF4444"],

        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "vertical",
            opacityFrom: 0.45,
            opacityTo: 0.05,
            stops: [0, 90, 100],
          },
        },

        xaxis: {
          categories: this.chartCategories,
          axisBorder: { show: false },
          axisTicks: { show: false },
        },

        yaxis: {
          labels: {
            show: true,
            style: {
              fontSize: "10px",
            },
            offsetX: this.$vuetify.rtl ? -80 : 0,
            formatter: (value) => {
              return `${this.$numberFormat(value)} ${this.$store.state.currency.name}`;
            },
          },
        },

        grid: {
          strokeDashArray: 4,
        },

        legend: {
          position: "bottom",
          horizontalAlign: "center",
        },

        tooltip: {
          y: {
            formatter(val) {
              return val.toLocaleString("fa-IR") + this.$store.state.currency.name;
            },
          },
        },

        dataLabels: {
          enabled: false,
        },
      };
    },
  },
  watch: {
    filterChart: {
      deep: true,
      handler(newVal) {
        this.getPettyMonth();
        newVal;
      },
    },
    advanceFilter: {
      deep: true,
      handler(newVal) {
        this.getPettyMonth(newVal);
      },
    },
  },
  mounted() {
    this.getPettyMonth();
  },
  methods: {
    getPettyMonth(filters = {}) {
      const hasDefaultDate = !!filters.fromDate && !!filters.toDate;
      const Type = hasDefaultDate ? false : "year";
      let UserList = [];
      let ProductList = [];
      if (
        filters.UserList != undefined &&
        filters.UserList != null &&
        filters.UserList != []
      ) {
        UserList = filters?.UserList.map((u) => u.id);
      }
      if (
        filters.products != undefined &&
        filters.products != null &&
        filters.products != []
      ) {
        ProductList = filters?.products.map((p) => p.id);
      }
      let app = this;
      app.loading = true;
      this.$axios
        .get(this.$endpoint + "dashboard/charts/invoice-by-month", {
          params: {
            dateType: Type,
            fromDate: filters.fromDate || null,
            toDate: filters.toDate || null,
            status: filters.sellStatus || [],
            accountIds: filters.account || [],
            branch: filters.branch || [],
            UserList: UserList || [],
            minAmount: filters.amountRange?.[0] ?? null,
            maxAmount: filters.amountRange?.[1] ?? null,
            ProductList: ProductList || [],
            productGroup: filters.productGroup || null,
            entrepot: filters.entrepot || null,
            attachment: filters.attachments || null,
            receipt: filters.Receipt || null,
            category: filters.category || null,
            minAmountTax: filters.amountRangeTax?.[0] ?? null,
            maxAmountTax: filters.amountRangeTax?.[1] ?? null,
            invoice_status: filters.status || null,
          },
        })
        .then((response) => {
          app.chartApiResponse = response.data?.data || {};
        })
        .catch((error) => {
          console.error("compare sell and profit chart error:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
::v-deep .apexcharts-legend.position-bottom .apexcharts-legend-series,
::v-deep .apexcharts-legend.position-top .apexcharts-legend-series {
  gap: 0.5rem;
  padding-top: 10px;
}
.chart-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
}
</style>
